import React, { useCallback, useState } from 'react';

import IneligiblePurchasesList from '../views/IneligiblePurchases/List';
import Search from '../views/Shared/Search';
import Pagination from '../views/Shared/Pagination';
import useMockGuarantees from '../hooks/useMockGuarantees';
import { useGuaranteeProduct } from '../hooks/useGuaranteePurchases';

const DEFAULT_PAGE_SIZE = 25;

const IneligiblePurchases = () => {
  const [selectedProduct] = useGuaranteeProduct();
  const [page, setPage] = useState(1);
  const [localSearchFields, setLocalSearchFields] = useState({});

  const {
    data, loading, isLastPage, start, end,
  } = useMockGuarantees({
    productFamily: selectedProduct || '',
    tab: 'ineligible',
    page,
    searchFields: localSearchFields,
  });

  // No modals for ineligible tab (placeholder per FR-8)
  const onSelectGuarantee = useCallback(() => {}, []);

  const onSearchSubmitHandler = useCallback(event => {
    event.preventDefault();
    const { vin, dealerNumbers } = event.target;
    const dealerNos = dealerNumbers && dealerNumbers.value ? [dealerNumbers.value.trim()] : [];
    const fields = {
      vin: vin ? vin.value.trim() || null : null,
      dealerNumbers: dealerNos,
    };
    setLocalSearchFields(fields);
    setPage(1);
  }, []);

  const nextHandler = useCallback(() => {
    if (!isLastPage) setPage(p => p + 1);
  }, [isLastPage]);

  const previousHandler = useCallback(() => {
    setPage(p => Math.max(1, p - 1));
  }, []);

  return (
    <div>
      <Search
        onSubmit={onSearchSubmitHandler}
        searchFields={{}}
        searchOptions={['vin', 'dealerNumbers']}
      />
      <IneligiblePurchasesList
        onSelectGuarantee={onSelectGuarantee}
        guaranteePurchases={data}
      />
      <Pagination
        start={start}
        end={end}
        nextHandler={nextHandler}
        previousHandler={previousHandler}
        loading={loading}
        lastPage={isLastPage}
        pageSize={DEFAULT_PAGE_SIZE}
      />
    </div>
  );
};

export default IneligiblePurchases;
